import styled from 'styled-components'
import { releaseInfoMobileDownQuery } from '../../responsiveQueries'

export const MetaWrapper = styled.div`
  width: 100%;
  padding: 24px 16px 40px 56px;
  overflow: hidden;

  @media ${releaseInfoMobileDownQuery} {
    padding: 20px 8px 32px 0;
  }
`
export const DetailsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px 32px;
  padding-bottom: 40px;

  @media ${releaseInfoMobileDownQuery} {
    grid-template-columns: 1fr;
  }
`

export const LyricsWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr;
  gap: 8px;
  padding-bottom: 40px;
`

export const RowWrapper = styled.div`
  border-top: ${({ theme }) => `1px solid ${theme.colors.neutralW30}`};
  padding-top: 40px;
`

export const Label = styled.span`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.neutralW60};
  line-height: 19px;
`

export const Formats = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const Details = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.neutralW80};
`

export const CopyableValue = styled.div`
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  width: fit-content;
  max-width: 100%;
`

export const CopyButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: ${({ theme }) => theme.colors.neutralW80};
  cursor: pointer;
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.neutralW100};
    background: ${({ theme }) => theme.colors.neutralW20};
  }
`

export const CopiedTooltip = styled.span`
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  z-index: 1;
  padding: 4px 8px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.neutralW50};
  color: ${({ theme }) => theme.colors.neutralW100};
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  white-space: nowrap;
  transform: translateX(-50%);
  pointer-events: none;
`

export const Lyrics = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  white-space: pre-wrap;
  color: ${({ theme }) => theme.colors.neutralW80};
`

export const ContentDetails = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.neutralW80};
`
export const GenreDetails = styled.div`
  display: flex !important;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.neutralW80};
  margin-right: 5px;
`
export const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
  color: ${({ theme }) => theme.colors.neutralW90};
  padding-bottom: 16px;
`
export const ReadSection = styled.button`
  display: inline-flex;
  width: fit-content;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.player50};
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
`
